import React from 'react';
import { Row, Col, Typography, Space } from 'antd';
import { DollarOutlined, ShoppingOutlined } from '@ant-design/icons';

import BotijaoIcon from '../../../assets/images/botijao.svg';
import { toLocaleMoney } from '../../../shared/services/NumberService';

const ProdutoValoresDetalhePedido = ({ order = {} }) => {
  return (
    <div>
      <Typography.Title level={2}>Produto e Valores</Typography.Title>
      <Space size='large' style={{ flexWrap: "wrap", gap: "1rem"}}>
        {order.products &&
          order.products.map((product) => {
            return (
              <div style={{display: "flex", flexDirection: "column"}}>
                <Row type={'flex'} style={{ flexWrap: "nowrap"}} gutter={14}>
                  <Col>
                    <img
                      style={{ width: 14, height: 14 }}
                      src={BotijaoIcon}
                      alt='icone botijao'
                    />
                  </Col>
                  <div style={{ display: "flex", flexWrap: "nowrap", gap: ".5rem"}}>
                    <Typography.Text>{product.tipoDescricao} </Typography.Text>
                    <span>-</span>
                    <Typography.Text> {product.marca.nome}</Typography.Text>
                  </div>
                </Row>

                <Row type={'flex'} gutter={14}>
                  <Col>
                    <div
                      style={{
                        background: '#ddd9d9',
                        padding: '0px 4px',
                      }}>
                      <span
                        style={{
                          fontSize: 12,
                        }}>
                        {product.quantidade}
                      </span>
                    </div>
                  </Col>
                  <Col>
                    <Typography.Text>
                      unidade
                      {product.quantidade > 1 ? 's' : ''}
                    </Typography.Text>
                  </Col>
                </Row>

                <Row type={'flex'} gutter={14}>
                  <Col>
                    <DollarOutlined />
                  </Col>
                  <Col>
                    <Typography.Text>
                      {toLocaleMoney(product.valor * product.quantidade)}
                    </Typography.Text>
                  </Col>
                </Row>
              </div>
            );
          })}
      </Space>
    </div>
  );
};

export default ProdutoValoresDetalhePedido;
